export default __webpack_public_path__ + "static/media/sr.5c5ecf54.svg";